<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer008">
<p class="pl-title"><a id="_idTextAnchor001"></a>Smooth-Talking Cowboy</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Smooth_Talking_Cowboy.vue?288be5fa